import React, { createContext, useContext, useState, useCallback } from 'react';

const GraphDataContext = createContext();

export const useGraphData = () => {
  const context = useContext(GraphDataContext);
  if (!context) {
    throw new Error('useGraphData must be used within a GraphDataProvider');
  }
  return context;
};

export const GraphDataProvider = ({ children }) => {
  const [graphData, setGraphData] = useState(null);
  const [filteredGraphData, setFilteredGraphData] = useState(null);
  const [unfilteredGraphData, setUnfilteredGraphData] = useState(null);

  const updateGraphData = useCallback((data) => {
    setGraphData(data);
  }, []);

  const updateFilteredGraphData = useCallback((data) => {
    setFilteredGraphData(data);
  }, []);

  const updateUnfilteredGraphData = useCallback((data) => {
    setUnfilteredGraphData(data);
  }, []);

  const value = {
    graphData,
    filteredGraphData,
    unfilteredGraphData,
    updateGraphData,
    updateFilteredGraphData,
    updateUnfilteredGraphData
  };

  return (
    <GraphDataContext.Provider value={value}>
      {children}
    </GraphDataContext.Provider>
  );
};
